import { Flex } from '@chakra-ui/react';
import { RadioFilter } from '../RadioFilter';
import { SearchInput } from './SearchInput';

interface GameListSortProps {
    sortValue: string;
    updateFilter: (val: string) => void;
    updateSearch: (val: string) => void;
}

export const SORT_GAMES = 'NO. OF GAMES';
export const SORT_PLAYERS = 'NO. OF PLAYERS';

export const GameListSorting: React.FC<GameListSortProps> = ({
    sortValue,
    updateFilter,
    updateSearch,
}) => {
    return (
        <Flex className={'gamelist-sort'}>
            <RadioFilter
                groupName="gamelist"
                options={[
                    {
                        option: SORT_GAMES,
                        className: 'gamelist-sort-filter',
                        selectedClassName: 'gamelist-sort-filter-selected',
                    },
                    {
                        option: SORT_PLAYERS,
                        className: 'gamelist-sort-filter',
                        selectedClassName: 'gamelist-sort-filter-selected',
                    },
                ]}
                defaultOption={SORT_GAMES}
                value={sortValue}
                onRadioChange={(newValue) => updateFilter(newValue)}
            />
            <SearchInput
                view="mobile"
                onSearchClear={() => updateSearch('')}
                onTriggerSearch={(searchText) => updateSearch(searchText)}
            />
        </Flex>
    );
};
